import cacheSessionStorage from '../cache/cacheSessionStorage'

const getters = {
  age: state => state.age
}

const state = {
  age: cacheSessionStorage.get('age', 18)
}

const mutations = {
  SET_AGE: (state, age) => {
    state.age = age
    cacheSessionStorage.set('age', age)
  }
}

const actions = {

}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
